import type { InvoiceBatchFilterSchema } from './invoice-batch-filter-schema';

export const invoiceBatchFilterDefaultValues: Readonly<InvoiceBatchFilterSchema> = {
  name: '',
  is_paid: false,
  invoices_creation_date: '',
  payment_date: '',
  payment_method: null,
} as const;
